import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import VideoPage from './components/VideoPage';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import Social from './components/Social';


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/Video" element={<VideoPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/Social" element={<Social />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
